<template>
	<div class="page">
		<div class="screenLine">
			<el-input v-model="keyword" placeholder="请输入关键字" style="width:240px;margin-right: 16px;" @keyup.enter.native="search"></el-input>
			<el-select class="titleSelect" v-model="status" @change="search" >
				<el-option
				v-for="item in [{label:'全部',value:'-1'},{label:'待审批',value:'0'},{label:'审批中',value:'1'},{label:'已同意',value:'2'},{label:'已驳回',value:'-2'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-select class="titleSelect" v-model="orderType" @change="search" >
				<el-option
				v-for="item in [{label:'全部',value:'-1'},{label:'商品',value:'1'},{label:'洗美',value:'2'},{label:'病例',value:'3'},{label:'疫苗驱虫',value:'4'},{label:'医疗服务',value:'5'},{label:'寄养',value:'6'},{label:'挂号',value:'7'},{label:'活体',value:'8'},{label:'虚拟类',value:'9'},{label:'订金',value:'10'},{label:'大礼包',value:'11'}]"
				:key="item.value"
				:label="item.label"
				:value="item.value">
				</el-option>
			</el-select>
			<el-date-picker @change="search" v-model="datetimerange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" style="margin-right:16px">
			</el-date-picker>
			<el-button type="primary" plain @click="reset">重置</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="订单类型" prop="careId">
					<template slot-scope="scope">
						{{scope.row.orderTypeName}}
					</template>
				</el-table-column>
				<el-table-column label="订单编号" prop="memberName">
					<template slot-scope="props">
						<div>{{props.row.refund_no}}</div>
					</template>
				</el-table-column>
				<el-table-column label="发起人" prop="petName">
					<template slot-scope="props">
						<div>{{props.row.operation_info.create.create_user.user_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="发起时间">
					<template slot-scope="props">
						{{$public.FTime(props.row.operation_info.create.create_time)}}
					</template>
				</el-table-column>
				<el-table-column label="可退款日期">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<el-popover placement="top-start" width="320" trigger="hover">
								<div>{{$public.FTime(item.beginDate)}} ~ {{$public.FTime(item.beginDate)}}</div>
								<div slot="reference">{{$public.FTime(item.beginDate,"MM-DD HH:mm")}} ~ {{$public.FTime(item.endDate,"MM-DD HH:mm")}}</div>
							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="审批状态" >
					<template slot-scope="props">
						<span v-if="props.row.status===0" style="color:#1890FF">待审批</span>
						<span v-if="props.row.status===1">审批中</span>
						<span v-if="props.row.status===2">已同意</span>
						<span v-if="props.row.status===-2" style="color:red">已驳回</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" >
					<template slot-scope="props">
						<el-button v-if="props.row.status===2||props.row.status===-2" type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-else type="text" size="mini" @click="see(props.row)">审批</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" :pageSize="page.pageSize" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data(){
			return{
				keyword:'',
				status:'-1',
				orderType:'-1',
				datetimerange:'',
				
				tableData:[],
				curItem:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		watch:{
			
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			reset(){
				this.keyword = ''
				this.status = '-1'
				this.orderType = '-1'
				this.datetimerange = ''
				this.page.page=1;
				this.getTableData()
			},
			// 查看
			see(row){
				this.curItem = row;
				this.$router.push({path:'/refundApprove/approveSee',query:{id:row._id}})
			},
			search(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"status": this.status,   //  -1 全部 0：待审批、1：审批中、2：已同意、-2.已驳回
					orderType:this.orderType, 
					"startTime": "",
					"endTime": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": (this.keyword).trim(),
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.startTime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/RefundAudit/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;
			.screenLineR{
				flex: 1;
				display: flex;
				justify-content: flex-end;
				.tabView{
					display: flex;
					align-items: center;
					width: 278px;
					height: 44px;
					background: #E7E7F4;
					border-radius: 10px;
					justify-content: space-around;
					.tabItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
					}
					.tabActiveItem{
						width: 90px;
						height: 36px;
						font-size: 14px;
						text-align: center;
						line-height: 36px;
						border-radius: 8px;
						background: #3A6DFF;
						color: #fff;
					}
				}
			}
			.titleSelect{
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>
